package com.appsyde.shared.modules.team.domain.model

sealed class CreateInviteResult {
    data class Ok(val inviteId: String) : CreateInviteResult()
    data object InvalidEmail : CreateInviteResult()
    data object CannotInviteOwner : CreateInviteResult()
    data object AlreadyMember : CreateInviteResult()
    data class Error(val message: String?) : CreateInviteResult()
}
